import { BannerHero } from "../../components/banner-hero/BannerHero";

const test = ({ layout }: { layout: string }): boolean =>
  layout === "Hero Banner";

const create = (props): JSX.Element => {
  return <BannerHero {...props} />;
};

export default { test, create };
